'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ClickableImage = _react2['default'].createClass({
    displayName: 'ClickableImage',


    propTypes: {
        imgSourceActive: _react2['default'].PropTypes.string.isRequired,
        imgSourceInactive: _react2['default'].PropTypes.string.isRequired,
        imgSourceActiveHeight: _react2['default'].PropTypes.number,
        imgSourceActiveWidth: _react2['default'].PropTypes.number,
        imgSourceInactiveHeight: _react2['default'].PropTypes.number,
        imgSourceInactiveWidth: _react2['default'].PropTypes.number,
        imgText: _react2['default'].PropTypes.string,
        isActive: _react2['default'].PropTypes.bool

    },
    getInitialState: function getInitialState() {
        return { isHover: false };
    },
    __onMouseEnter: function __onMouseEnter() {
        this.setState({ isHover: true });
    },
    __onMouseLeave: function __onMouseLeave() {
        this.setState({ isHover: false });
    },
    render: function render() {

        if (this.props.isActive || this.state.isHover) {
            return _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement(
                    'div',
                    { onMouseEnter: this.__onMouseEnter, onMouseLeave: this.__onMouseLeave, className: 'm-tabs_tiles--tileWrapper' },
                    _react2['default'].createElement('span', { className: 'm-tabs_tiles--center-helper' }),
                    _react2['default'].createElement('img', { width: this.props.imgSourceActiveWidth, height: this.props.imgSourceActiveHeight, className: 'm-tabs_tiles--clickable-img', src: this.props.imgSourceActive })
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-tabs_tiles--tile-text-container ' },
                    _react2['default'].createElement(
                        'p',
                        null,
                        this.props.imgText
                    )
                )
            );
        } else {
            return _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement(
                    'div',
                    { onMouseEnter: this.__onMouseEnter, onMouseLeave: this.__onMouseLeave, className: 'm-tabs_tiles--tileWrapper show-for-large-up' },
                    _react2['default'].createElement('span', { className: 'm-tabs_tiles--center-helper' }),
                    _react2['default'].createElement('img', { width: this.props.imgSourceInactiveWidth, height: this.props.imgSourceInactiveHeight, className: 'm-tabs_tiles--clickable-img', src: this.props.imgSourceInactive })
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-tabs_tiles--tile-text-container show-for-large-up' },
                    _react2['default'].createElement(
                        'p',
                        null,
                        this.props.imgText
                    )
                )
            );
        }
    }
});

module.exports = ClickableImage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/tabbed-area/clickable-image.jsx
 ** module id = 1138
 ** module chunks = 0
 **/